import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";
import { getUserDetails } from "../utils/userDetailsUtils";

const fetchTestSuite = async (id, viewDeleted = false) => {
  const user = getUserDetails();

  const params = new URLSearchParams({
    action: "getTestSuites",
    companyid: user.companyid,
    productid: id,
  });

  if (viewDeleted) {
    params.append("viewDeleted", "true");
  }

  const response = await axios.get(`${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?${params}`);

  return response.data;
};
const useTestSuiteQueryNew = (id, enabled = false, viewDeleted = false) => {
  return useQuery({
    queryKey: ["testSuiteNew", id, viewDeleted],
    queryFn: () => fetchTestSuite(id, viewDeleted),
    enabled: enabled && !!id,
    // retry: 1,
    // cacheTime: 90000,
    // refetchInterval: false,
    // refetchIntervalInBackground: false,
    // staleTime: 5 * 60 * 1000,
    // onError: (error) => {
    //   console.error("Query error in useTestSuiteQueryNew:", error);
    // },
  });
};

export default useTestSuiteQueryNew;
